export const upperCaseBrands = [
  '16EAST',
  '3 COM',
  '3DCONNEXION',
  '3DWERK',
  '3G',
  '3M',
  'A MODO MIO',
  'A.H.B. FORM DESIGN',
  'A.S.T',
  'A1',
  'A4TECH',
  'ABUS',
  'AC RYAN',
  'ACCESSORIZE',
  'ACCLAIM',
  'ACCURIDE',
  'ACME',
  'AD NOTAM',
  'ADAC',
  'ADAPTEC',
  'ADATA',
  'ADOBE',
  'ADONIT',
  'ADS',
  'AEG',
  'AEGIS',
  'AERIAL7',
  'AFK',
  'AGFEO',
  'AGI',
  'AHA',
  'AIGO',
  'AIV',
  'AIXTRASOLAR',
  'AK TRONIC SOFTWARE',
  'AKG',
  'AKO',
  'ALADIN EASYCLICK',
  'ALBRECHT',
  'ALDENKAMP',
  'ALECTO',
  'ALL4U',
  'ALLSOP',
  'ALNO',
  'ALPHATRONICS',
  'ALPS',
  'ALSO ABC',
  'ALTO VALERIAN',
  'AM',
  'AMBIANCE TECHNOLOGY',
  'AMPLICOM POWER',
  'ANIMAL',
  'ANITECH',
  'ANKARO',
  'ANSMANN',
  'ANUBIS',
  'ANYCOM',
  'ANYMODE',
  'AOL',
  'AOPEN',
  'APACER',
  'APC',
  'APOLLO BELL',
  'APPGEAR',
  'AQIPA',
  'AR',
  'ARCOR',
  'ARDES',
  'ARENA',
  'ARGO',
  'ARGON',
  'ARIETE',
  'ARIMA',
  'ARION',
  'ARLETT',
  'ARNOVA',
  'ARTIST',
  'ARTWIZZ',
  'A-SOLAR',
  'ASPERA',
  'ASSISTENT',
  'ASTRA',
  'ASUSTOR',
  'ATECA',
  'ATELCO',
  'ATOMIC',
  'AUDIO PRO',
  'AUDIO TECHNICA',
  'AUDIORAQ',
  'AUDIOVOX',
  'AUDIOXPERTS',
  'AUERSWALD',
  'AURO',
  'AUTOSONIC',
  'AUTOVOX',
  'AUVIPARTS',
  'AVALON',
  'AVANCA',
  'AVERATEC',
  'AVERMEDIA',
  'AVF',
  'AVINITY',
  'AVINTAGE',
  'AVM',
  'AXING',
  'AYANO',
  'B.A.T',
  'B.COM',
  'B.E.G.',
  'B+W FILTER',
  'BALCAR COLLECTION',
  'BALLISTIC',
  'BALLPOD',
  'BAMIX',
  'BANDAI NAMCO',
  'BANDRIDGE',
  'BARBIE',
  'BARISTA CLUB',
  'BARKAN',
  'BASE',
  'BASIC XL',
  'BASIS',
  'BAVARIA',
  'BAYAN AUDIO',
  'BAYCOM',
  'BAYER',
  'BEBOOK',
  'BECKER',
  'BECO',
  'BEDEA',
  'BEEWI',
  'BELDIGITAL',
  'BELINEA',
  'BELMOCA',
  'BELUX',
  'BENCH',
  'BENQ',
  'BERG',
  'BERNSTEIN',
  'BESSER VACUUM',
  'BESTMEDIA',
  'BESTRON',
  'BEURER',
  'BEYERDYNAMIC',
  'BIALETTI',
  'BIGBEN INTERACTIVE',
  'BIMAR',
  'BIRKHOLD KG',
  'BITDEFENDER',
  'BLING MY THING',
  'BLOCK',
  'BLU:S',
  'BLUEMEDIA',
  'BLUEROOM',
  'BLUESTATE',
  'BLUESTEAM',
  'BOB HOME',
  'BOCA',
  'BOEDER',
  'BOMANN',
  'BONECO',
  'BORETTI',
  'BQ',
  'BRAINWAVE',
  'BRANEX DESIGN',
  'BREMA',
  'BRENNENSTUHL',
  'BRITA',
  'BRONDI',
  'B-RUN',
  'BTR TELECOM',
  'BUFFALO',
  'BUGATTI',
  'BUHL DATA SERVICE',
  'BULLGUARD',
  'BURG',
  'BURY',
  'BUSCH-JAEGER',
  'BWT BEST WATER TECHNOLOGY',
  'CABLECON',
  'CADAC',
  'CAFÉ ROYAL',
  'CAFE SATI',
  'CAMSPORTS',
  'CANADIANSOLAR',
  'CANAL DIGITAAL',
  'CANTON',
  'CANYON',
  'CAPTIVA',
  'CARCOMM',
  'CARMEN',
  'CARMENGIRLS',
  'CASE MATE',
  'CASELOGIC',
  'CASO',
  'CAT',
  'CAVEL',
  'CDC',
  'CD-LIEFERANT',
  'CEBOP',
  'CECONET',
  'CELESTRON',
  'CELLINI',
  'CELLULARLINE',
  'CELLUX',
  'CEMOBIT',
  'CEWE COLOR',
  'CGV',
  'CHANGHONG',
  'CHEF´S CHOICE',
  'CHERRY',
  'CHI',
  'CHIEMSEE',
  'CHILIGREEN',
  'CIDA',
  'CIMCO',
  'CISCO',
  'CLARO SWISS',
  'CLEARWHITE',
  'CLIMADIFF',
  'CLOER',
  'CMX',
  'CNM',
  'COLAG',
  'COLE & MASON',
  'COLLO',
  'COLORTAC-DISPLAYS',
  'COLOUD',
  'COMAG',
  'COMAT',
  'COMFEE',
  'COMTEAM',
  'CONCORD',
  'CONGSTAR',
  'CONNECTIVITY GROUP',
  'CONTINENT',
  'CONTOUR',
  'COOLBANANAS',
  'COOLER MASTER',
  'COOLPAD',
  'COOLSTAR',
  'COREL',
  'CORKCASE',
  'CORSAIR',
  'CORTINA',
  'COSA',
  'COTTONCARRIER',
  'COWON',
  'CREATIVE',
  'CREMESSO',
  'CROCFOL',
  'CROMARGOL',
  'CROSSCALL',
  'CRUMPLER',
  'CRUNCH',
  'CUBIFY',
  'CUISINART',
  'CUSTOM MADE',
  'CYGNETT',
  'D2D',
  'D2-VODAFONE',
  'DAIKIN',
  'DAIMON',
  'DA-LITE',
  'DANGAARD',
  'DAS SYSTEMHAUS',
  'DATA BECKER',
  'DATAFLEX',
  'DATALUX',
  'DAYTEK',
  'DAZZLE FAST',
  'D-DESIGN',
  'DEA',
  'DEBITEL',
  'DEFINITIVE TECHNOLOGY',
  'DEJA',
  'DELPHI GRUNDIG',
  'DELSEY',
  'DELWA STAR',
  'DENVER',
  'DESSAUER',
  'DETEWE',
  'DEVOLO',
  'DEXFORD',
  'DEXIM',
  'DICOTA',
  'DIGICOM',
  'DIGITALBOX',
  'DIKOM',
  'DISPLEX',
  'DJ-TECH',
  'DK-DIGITAL',
  'DL',
  'D-LINK',
  'DNT',
  'DOLCE VITA',
  'DOMETIC',
  'DOMO',
  'DOSCH + AMAND',
  'DOUWE EGBERTS',
  'DR. OETKER',
  'DR.KERN',
  'DREAMLAND',
  'DREILAENDERFUNK',
  'DREUSICKE',
  'DRIFT',
  'DSC ZETTLER',
  'DTP',
  'DUERKOP',
  'DURACELL',
  'DURGOL',
  'DVICO',
  'DYNAUDIO',
  'DYNAVOX',
  'DYON',
  'E+K DATA',
  'E+P',
  'EAGLE CABLE',
  'EASTPAK',
  'EASY ONE',
  'EASYMEDIA',
  'EBD',
  'EBERLE',
  'ECE',
  'ECM',
  'ECOLAMP',
  'ECOMED',
  'ECOVACS',
  'ED HARDY',
  'EDDING',
  'EDEL+WHITE',
  'EDIFIER',
  'EDITIONS LE ROBERT',
  'EDITIONS PROFIL',
  'EDY',
  'EFBE-SCHOTT',
  'EFS',
  'EGING',
  'EGS',
  'EIDOS INTERACTIVE',
  'EIO',
  'EIZO',
  'ELBRO',
  'ELECOM',
  'ELECTRONIA',
  'ELECTRONIC ARTS',
  'ELEKTRA BREGENZ',
  'ELEKTRONIA',
  'ELEMENT CASE',
  'ELETTROCASA',
  'ELGATO',
  'ELKA PIETERMAN',
  'ELLRONA',
  'ELMARC',
  'ELMEG',
  'ELRO',
  'ELSA',
  'ELSON',
  'ELTA',
  'ELTAC',
  'EMC',
  'EMERIO',
  'EMINENT',
  'EMPORIA',
  'ENERGETIC',
  'ENOX',
  'EON',
  'EPAY',
  'EPE',
  'E-PLUS',
  'EPSITEC',
  'ERARD',
  'ERGOLINE',
  'ESGE',
  'ESPRIMO',
  'ESTRO',
  'ESX',
  'EUDORA',
  'EUREKA',
  'EVERLAST',
  'EVESTAR',
  'EVOUCHER',
  'EWT',
  'EXACTA',
  'EXELIUM',
  'EXXTER',
  'EYCOS',
  'EZETIL',
  'FABULED',
  'FAKIR',
  'FAKTOR ZWEI',
  'FALK',
  'FANTASEA',
  'FAVEO',
  'FAWA',
  'FELLOWES',
  'FERO',
  'FERTIG SOLAR',
  'FINAL SOUND',
  'FINEPASS',
  'FIRST CLASS',
  'FISSLER',
  'FITBIT',
  'FIX2CAR',
  'FLAEMNUOVA',
  'FLAMMEX PROFI',
  'FLASHPOINT',
  'FLATRON',
  'FLEXTRON',
  'FLYMOUNT',
  'FMIF',
  'FOCAL',
  'FONTASTIC',
  'FOODSAVER',
  'FORON',
  'FORS',
  'FOTOPRO',
  'FRANKLIN',
  'FREENET',
  'FRIEDLAND',
  'FRIFRI',
  'FRITEL',
  'FRONIUS',
  'FT',
  'FYSIC',
  'G DATA SOFTWARE',
  'G&BL',
  'GAINWARD',
  'GALA',
  'GALAXIS',
  'GAMERON',
  'GASTROBACK',
  'GE',
  'GEHA',
  'GEHRIG',
  'GEMBIRD',
  'GENERAL IMAGING',
  'GENEVA',
  'GENIUS',
  'GEPE',
  'GERICOM',
  'GERMATIC',
  'GGV',
  'GIOTECK',
  'GIOTTOS',
  'GIRMI',
  'GITZO',
  'GLOBAL SYSTEMS',
  'GLÖÖCKLER',
  'GOLDBERG',
  'GOLDEN MEDIA',
  'GOLLA',
  'GOOBAY',
  'GOOGLE',
  'GOPOLE',
  'GOPRO',
  'GOURMET MAXX',
  'GOURMET WAVE',
  'GP BATTERY',
  'GRAEF',
  'GRANDTEC',
  'GRIFFIN',
  'GRIPIS',
  'GROUND ZERO',
  'GSE',
  'GT SAT',
  'GUZZINI',
  'H+H',
  'HAGENUK',
  'HAILO',
  'HAMANN',
  'HANNS.G',
  'HANSOL',
  'HAPPY PLUGS',
  'HAPRO',
  'HARTIG + HELLING',
  'HARVEST',
  'HARWA',
  'HAUPPAUGE',
  'HB',
  'HCM',
  'HD+',
  'HDIGIT',
  'HEBOR',
  'HEGRA',
  'HEITECH',
  'HELIX',
  'HELLER',
  'HELLUM',
  'HP',
  'HI_FUN GMBH',
  'HIFONICS',
  'HMDX',
  'HOMECAST',
  'HONL PHOTO',
  'HOTMEDIA',
  'HOUSECOM SOLUTIONS',
  'HOWELL',
  'HQ',
  'HTC',
  'HTI',
  'HYRICAN',
  'I&C',
  'IAUDIO',
  'IBM',
  'IC',
  'ICARUS',
  'ICC',
  'ICECRYPT',
  'ICIDU',
  'ICL',
  'ICLAW',
  'ICONBIT',
  'ICR',
  'ICS',
  'ICUBE',
  'ICY BOX',
  'ID SAT',
  'IDAPT',
  'IDDIGITAL',
  'IDE',
  'IDECT',
  'IDEEO',
  'IFROGZ',
  'IGO',
  'I-GOTU',
  'IGRIP',
  'IGU',
  'IHEALTH',
  'IKEA',
  'ILLUDEC',
  'ILSONIC',
  'IMATION',
  'IMAZE',
  'IMETEC',
  'IMI',
  'INAKUSTIK',
  'INGRAM MICRO',
  'INNERGIE',
  'INSTA PARTNER',
  'INTEGRAL',
  'INTENSO',
  'INTERFUNK',
  'INTERKABEL',
  'INTERSOUND',
  'INTRADO',
  'INTREEO',
  'INVENTUM',
  'INVERTO',
  'INVISIBLESHIELD',
  'IOMEGA',
  'ION',
  'IQ',
  'IQM',
  'IRIG',
  'ISTUFF',
  'ISY',
  'ITECH',
  'ITS',
  'ITTRAVEL',
  'ITUNES',
  'IXOS',
  'J.B.L',
  'JABRA',
  'JACOBS',
  'JAEGER',
  'JAHNKE',
  'JAM',
  'JAMBA',
  'JANATIC',
  'JATA',
  'JAVA',
  'JAWBONE',
  'JAY-TECH',
  'JEAN COMPANY',
  'JGC',
  'JIM BEAM',
  'JOBO',
  'JOBY',
  'JO-EL',
  'JOSEPH JOSEPH',
  'J-STRAPS',
  'JUMBO',
  'JUPITER',
  'JUST MOBILE',
  'JVC',
  'K.E.F.',
  'KACO',
  'KAERCHER',
  'KALKMANN-AUDIO',
  'KALORIK',
  'KASPERSKY',
  'KATA',
  'KATHREIN',
  'KATINKAS',
  'KAZAM',
  'KD GROUP',
  'KEEWAY',
  'KEF',
  'KEITH HARING',
  'KENSINGTON',
  'KERTESZ',
  'KIANO',
  'KICKER',
  'KILIAN KERNER',
  'KINGSTON',
  'KISS',
  'KLICKTEL',
  'KLIKAANKLIKUIT',
  'KLIPSCH',
  'KMP',
  'KOCH MEDIA',
  'KÖNIG',
  'KONAMI',
  'KONKIS',
  'KOPP',
  'KORONA',
  'KOSCHI',
  'KOSS',
  'KPN',
  'KREILING',
  'KRUSELL',
  'KRYSTAL TECH LYNX',
  'KUHN RIKON',
  'KUKUXUMUSU',
  'KWS',
  'L&S ELECTRONIC',
  'LA PAVONI',
  'LABTEC',
  'LACIE',
  'LACOR',
  'LADIES COLLECTION',
  'LAGRANGE',
  'LAICA',
  'LATTEMENTO',
  'LAURA STAR',
  'LAURUS',
  'LAVA',
  'LAVAZZA',
  'LAWRENCE TEA',
  'LEADTEK',
  'LEBARA MOBILE',
  'LECLANCHÉ',
  'LED LENSER',
  'LEDINO',
  'LEGO',
  'LEIFHEIT',
  'LEKKERLAND',
  'LEMON',
  'LENTEC',
  'LENUSS',
  'LEONARD',
  'LEONARDO',
  'LEO-SYSTEMS',
  'LEXWARE',
  'LFD',
  'LG',
  'LIFEPROOF',
  'LINKSYS',
  'LINTEC',
  'LIQUID IMAGE',
  'LISTENER SICHERHEITSSYSTEME',
  'LLONGUERAS',
  'LOGICOM',
  'LOTUSGRILL',
  'LOWEPRO',
  'LPK',
  'LUBIX',
  'LUCKY FINISH',
  'LYCAMOBILE',
  'M&S',
  'MAC AUDIO',
  'MACLOVE',
  'MACOM',
  'MACROTRON',
  'MAD CATZ',
  'MAG',
  'MAGELLAN',
  'MAGIC SING',
  'MAGIMIX',
  'MAGINON',
  'MAGIX',
  'MAGLITE',
  'MAGNAT',
  'MAGNAVOX',
  'MAN&WOOD',
  'MANFROTTO',
  'MARIASOLE',
  'MARKETING',
  'MARLEY',
  'MARMITEK',
  'MARQUANT',
  'MARTEX',
  'MARYNEN',
  'MASCOM',
  'MASTERCOOK',
  'MASTERGRILL',
  'MASTERVOLT',
  'MATSUSHITA',
  'MATTEL',
  'M-AUDIO',
  'MAUI SPORTS',
  'MAX',
  'MAXDATA',
  'MAXDOME',
  'MAXELL',
  'MAXFIELD',
  'MAXIMUM',
  'MAXTOR',
  'MAXXTRO',
  'MAYBAUM',
  'MBO',
  'MB-QUART',
  'MCAFEE',
  'MC-TRONIC',
  'MEBUS',
  'MEDIACOM',
  'MEDIASHOPPING',
  'MEDIOLA',
  'MEDISANA',
  'MEDIUM',
  'MEGAS',
  'MELICONI',
  'MELITTA',
  'MEMORY SOLUTION GMBH',
  'MENALUX',
  'MENZ + KÖNECKE',
  'METRONIC',
  'MH',
  'MICHELIN',
  'MICROLIFE',
  'MICROMEL',
  'MICROSTAR-PC',
  'MIDEA',
  'MIDWAY GAMES',
  'MINDSCAPE',
  'MINGES',
  'MIPOW',
  'MIRABELLE',
  'MIRAI',
  'MIRO',
  'MISUMI',
  'MITSUI',
  'MK',
  'MLINE',
  'MOBI',
  'MOBIBLUE',
  'MOBILIZE',
  'MOBISTAR',
  'MOCCAMASTER',
  'MO-EL',
  'MONACOR',
  'MONEUAL',
  'MONIN',
  'MONITORS + MORE',
  'MONLINES',
  'MONRAY',
  'MONTANA',
  'MONXX',
  'MORACH-TECHNIK',
  'MORAVIA (ZR)',
  'MOSER',
  'MOSERBAER',
  'MOUNTAINSMITH',
  'MP MAN',
  'MPE DIFFUSION',
  'MPIO-PEROS',
  'M-ROCK',
  'MSI',
  'MTC',
  'MUNARI',
  'MUSICMAN',
  'MUSUBO',
  'MUVID',
  'MY WALL',
  'MYKRONOZ',
  'NAD',
  'NAF NAF',
  'NANO',
  'NANOXX',
  'NATCOM',
  'NATIONAL GEOGRAPHIC GEAR',
  'NAVIFLASH',
  'NAVILOCK',
  'NAVJACK',
  'NCR',
  'NEDIS',
  'NEO',
  'NEOTION',
  'NERSQUARE',
  'NESCAFE',
  'NETATMO',
  'NETSQUARE AG',
  'NEUTRALE WERBEMITTEL',
  'NEWSTAR',
  'NEXPOD ORO',
  'NEXTBASE',
  'NIKE',
  'NIKKO',
  'NILOX',
  'NISSIN',
  'NIVONA',
  'NIWO',
  'NIWOTRON',
  'NIXDORF',
  'NOBILIS',
  'NORGE',
  'NORMA',
  'NOSEC',
  'NOSER',
  'NOVIS',
  'NOVISSA',
  'NOXON',
  'NTP',
  'NUANCE',
  'O2',
  'OBO BETTERMANN',
  'OCZ',
  'ODYS',
  'OEHLBACH',
  'OK',
  'OLIDATA',
  'OLIMPIA SPLENDID',
  'OMNIMOUNT',
  'ONE FOR ALL',
  'ONLINE USV',
  'OPENTEL',
  'OPPO',
  'OPTUS',
  'ORBITECH',
  'ORBYX',
  'ORDISSIMO',
  'ORG/DV-INTERN',
  'ORIEME',
  'ORKIO',
  'OSRAM',
  'OTELO',
  'OTTERBOX',
  'OUTDOOR CHEF',
  'OXFORD',
  'OXYPURE',
  'OZAKI',
  'P&B PICARD&BIRKENSTOCK',
  'PANDARO SYSTEMS',
  'PANOVIEW',
  'PANTECH',
  'PAPYRUS',
  'PATACO',
  'PATONA',
  'PCTV SYSTEMS',
  'PE',
  'PEACH',
  'PEAQ',
  'PEBBLE',
  'PEDEA',
  'PEERLESS',
  'PELGRIM',
  'PELIKAN',
  'PERES',
  'PERFECT PRO',
  'PETER JÄCKEL',
  'PETRA ELECTRIC',
  'PFEIFER',
  'PHARAO',
  'PHICOMM',
  'PHOCUS',
  'PHONAK AUDÉO PFE',
  'PHONIX',
  'PHYSIX',
  'PIEGA',
  'PINELL',
  'PINNACLE SYSTEMS',
  'PIRANHA',
  'PKM',
  'P-LABOR',
  'PLANTRONICS',
  'PLASFIX',
  'PLATINUM',
  'PLATIUMED',
  'PLAYART',
  'PLAYBOY',
  'PLEOMAX',
  'PLEXTOR',
  'PLUSTEK',
  'PNY',
  'POCKETBOOK',
  'POCKETMEDIA',
  'POINT OF VIEW',
  'POLK',
  'POLYTRON',
  'POPP',
  'PORT',
  'POWERA',
  'PP3DP',
  'PREMIERE',
  'PRESTIGIO',
  'PRIMAX',
  'PRIME TIME',
  'PRINCESS',
  'PRINCETON',
  'PRIVILEG',
  'PROCOLOR',
  'PROFECTIS',
  'PROFICOOK',
  'PROFIGOLD',
  'PROFOON',
  'PROJECTA',
  'PROMAX',
  'PROMELIT',
  'PRO-SET',
  'PROVIEW',
  'PRO-VISION',
  'PUMA',
  'PURE ACOUSTICS',
  'PURELINK',
  'PURO',
  'PYLE',
  'Q',
  'QDOS',
  'QIOTTI',
  'QLIMA',
  'QMS',
  'QNAP',
  'QOBOS',
  'QTEK',
  'RADEON GRAPHICS',
  'RADIO-MATERIEL',
  'RADIOTONE',
  'RADIX',
  'RAIDSONIC',
  'RAM COMPONENTS',
  'RAPOO',
  'RAPTOR GAMING',
  'RATHO',
  'RAZER',
  'REAL CABLE',
  'RED BULL RACING',
  'RED STAR',
  'REEL MULTIMEDIA',
  'REFLEKTA',
  'REFLEXION',
  'RENEGADE',
  'RENESOLAR',
  'RENOWAY',
  'RETEC MOBILE ELECTRONIC',
  'REVAH TELE',
  'REVITIVE',
  'REYCOM',
  'RFT',
  'RGV',
  'RHEIN-MAIN-PAPIER',
  'RICATECH',
  'RITTER',
  'ROADSIGN',
  'ROBOMOW',
  'ROCCAT',
  'ROCKRIDGESOUND',
  'ROESCH-ELECTRIC',
  'ROGUE',
  'ROKA',
  'ROLINE',
  'ROMMELSBACHER',
  'ROUTE 66',
  'ROUTIN',
  'RST',
  'RUNTASTIC',
  'RWE',
  'RZB',
  'S&T TECH-PC',
  'S+M REHBERG',
  'S+S',
  'SABINE KOBER',
  'SAECO',
  'SAILOR',
  'SALCO',
  'SALTER',
  'SAMPO',
  'SAMSONITE',
  'SAMTRON',
  'SANAAIR',
  'SANDISK',
  'SANITAS',
  'SANUS',
  'SANVIA',
  'SATFORCE',
  'SATIX',
  'SATZUMA',
  'SAVE GREEN',
  'SAVELLI',
  'SBS',
  'SCANPART',
  'SCANSONIC',
  'SCEI',
  'SCHAUB LORENZ',
  'SCHLETTER',
  'SCHNEPEL',
  'SCHOENENBERGER',
  'SCHWAIGER',
  'SCOTT',
  'SCREEN LINE',
  'SEAGATE',
  'SEB',
  'SEECODE',
  'SEG',
  'SEGAFREDO',
  'SEIKI',
  'SELECT',
  'SELFSAT',
  'SENDSTATION',
  'SENSOLUX',
  'SENZA',
  'SEPPELFRICKE',
  'SERVICEPARTNER',
  'SET ONE',
  'SEVERIN',
  'SIBIR',
  'SIGALUX',
  'SILICON POWER',
  'SILVA',
  'SILVERLIT',
  'SIMPLE-HUMAN',
  'SIMPLITV',
  'SIPWELL',
  'SITECOM',
  'SK',
  'SKC LIGHTING',
  'SKROSS',
  'SKULLCANDY',
  'SKYMASTER',
  'SKYMEDIA',
  'SKYPE',
  'SKY-VISION',
  'SLIK',
  'SMA',
  'SM-ELEKTRONIK',
  'SMILE MOBILE',
  'SMILEY',
  'SMIT',
  'SOBA',
  'SODA FRESH',
  'SODASTREAM',
  'SOEHNLE',
  'SOL REPUBLIC',
  'SOLAC',
  'SOLARMAX',
  'SOLARWORLD',
  'SOLIS',
  'SONALIS',
  'SONANCE',
  'SONIM',
  'SONNENKOENIG',
  'SONORO',
  'SONOROUS',
  'SONUS FABER',
  'SOUND2GO',
  'SOUNDCAST',
  'SOUNDMASTER',
  'SOVELLO',
  'SOVENTIX',
  'SOX',
  'SPADA',
  'SPALLUTO',
  'SPAUN ELECTRONIC',
  'SPECK',
  'SPECTRAL',
  'SPEED LINK',
  'SPEER',
  'SPIDEM',
  'SPIDERPAD',
  'SPRINTER',
  'STABO',
  'STADLER FORM',
  'STARS',
  'STEBA',
  'STEELSERIES',
  'STEINEL',
  'STEINER',
  'STK',
  'STOECKLI',
  'STONEWIRE',
  'STRONG',
  'STUDIO',
  'STYLIES',
  'SUNENERGY.',
  'SUNOWE',
  'SUNRISE',
  'SUNSTAR',
  'SUNSTECH',
  'SUNTEC',
  'SUPERFLOWER',
  'SUPERTECH',
  'SUPERTOOTH',
  'SUPPORT PLUS',
  'SWATCH',
  'SWEEX',
  'SWIRL',
  'SWISS GARDE',
  'SWISS TRAVEL PRODUCTS',
  'SWISSLINE',
  'SWISSTONE',
  'SWITCHEASY',
  'SYBEX-VERLAG',
  'SYLVANIA',
  'SYMANTEC',
  'SYNOLOGY',
  'SYSTEM AUDIO',
  'T&H',
  'T.O.A',
  'T+A ELEKTROAKUSTIK',
  'T3',
  'TAKE 2',
  'TAMASHI',
  'TAMRAC',
  'TANGENT',
  'TARGUS',
  'TAURUS',
  'TCL',
  'TCM',
  'T-COM',
  'TDA',
  'TDK',
  'TDL',
  'TEAMPAD',
  'TEC',
  'TECH21',
  'TECHLINE',
  'TECHNAXX',
  'TECHNIVIOLA',
  'TECHNOCRAFT',
  'TECHNOLINE',
  'TECHNOTREND',
  'TECNOGAS',
  'TEEKANNE',
  'TELE2',
  'TELEKOM',
  'TELESTAR',
  'TELESYSTEM',
  'TELETECH',
  'TELEVES',
  'TELFORT',
  'TELI TAL',
  'TELME',
  'TELNET/TELEBAU',
  'TELSKY',
  'TENBA',
  'TENSAI',
  'TERMIKEL',
  'TERMOZETA',
  'TERRA',
  'TERRATEC',
  'TETRAX',
  'TFA',
  'THES',
  'THOMAS',
  'THOMAS & BETTS',
  'T-HOME',
  'THQ ENTERTAINMENT',
  'THRUSTMASTER',
  'THUECOB',
  'THULE',
  'TIFFEN',
  'TIME NEDERLAND',
  'TIPTEL',
  'TIVOLI',
  'TODDYGEAR',
  'TOMTOM',
  'TOPCOM',
  'TOPP-DESIGN',
  'TOPPITS',
  'TP VISION',
  'TPV',
  'TRABO',
  'TRANSCEND',
  'TRANSMEDIA',
  'TRANSONIC',
  'TRANSTHERM',
  'TREKSTORE',
  'TREVI',
  'TREXTA',
  'TRINLOC',
  'TRIUMPH-ADLER',
  'TS',
  'TTAF',
  'TTM',
  'TUCANO',
  'TURKCELL',
  'TURMIX',
  'TWELVE SOUTH',
  'TWENTIETH CENTURY FOX',
  'TWINHEAD',
  'TX',
  'TYPHOON',
  'U.S. ROBOTICS',
  'UBISOFT',
  'UCS-PC',
  'UDO WALZ',
  'UHER',
  'UKPRO',
  'ULTRASONE',
  'ULTRON',
  'UNEX LED',
  'UNITED',
  'UNITEKNO',
  'UNITYMEDIA',
  'UNIVERSUM',
  'UNOLD',
  'UNOMAT',
  'URBAN EARS',
  'URBAN REVOLT',
  'UTANO',
  'UUNIQUE',
  'V7 VIDEOSEVEN',
  'VALENTA',
  'VALENTINOS',
  'VALERA',
  'VALUE',
  'VANGUARD',
  'VANTAGE',
  'VANTAGE POINT',
  'VARTA',
  'VCM',
  'VDO',
  'VECTONE',
  'VELBON',
  'VELLEMAN',
  'VENGA',
  'VENTA',
  'VERBATIM',
  'VERSO',
  'VESEG',
  'VIAMICHELIN',
  'VICIOUS AND DIVINE',
  'VIDEOWEB',
  'VIDIS',
  'VIEW QUEST',
  'VINCENT',
  'VIOLA DIGITAL',
  'VISIOSAT',
  'VIVITEK',
  'VL',
  'VOBIS',
  'VOGEL`S',
  'VOLKSWAGEN',
  'VONINO',
  'VOSSLOH-SCHWABE',
  'V-ZUG',
  'WAECO',
  'WAFRI',
  'WALIMEXPRO',
  'WALZ',
  'WAMSLER',
  'WATERKANT',
  'WATERPIK',
  'WAVES',
  'WEBELLEN',
  'WEBER',
  'WECARE4',
  'WEINBERGER',
  'WELCO',
  'WELTCO',
  'WELTEC',
  'WERIT',
  'WESC',
  'WETZELS KAFFEEMÜHLE',
  'WEYBROOK',
  'WHATEVER IT TAKES',
  'WHD',
  'WHITE DIAMONDS',
  'WHITE LABEL',
  'WHOOP',
  'WICK',
  'WIDMER',
  'WIK',
  'WIKO',
  'WINTECH',
  'WISI',
  'WMF',
  'WOLF',
  'WORLD OF VISION',
  'WORTMANN',
  'WPRO',
  'XAVAX',
  'XELO-SYSTEMS',
  'XFX',
  'X-MINI',
  'XORO',
  'XQISIT',
  'XSORIES',
  'X-TENSIONS',
  'XTREMEMAC',
  'XYZPRINTING',
  'YAKUMO',
  'YALLO',
  'YAMAKAWA',
  'YINGLI SOLAR',
  'ZEHNDER',
  'ZELMER',
  'ZENITH',
  'ZEROTHERM',
  'ZIBRO',
  'ZIGGO',
  'ZTE',
  'ZÜBLIN',
  'ZWECKFORM',
  'ZYLISS',
  'ZYXEL',
  'ARGOS',
  'AO',
  'B&Q',
  'HSBC',
  'RBOS',
  'RBS',
  'RSA',
  'ANIMALCARE CAT 1*',
  'ANIMALCARE CAT 2*',
  'ANIMALCARE CAT 3*',
  'ANIMALCARE SUP CATS',
  'ANIMALCARE STD CATS',
  'ANIMALCARE DOG 1*',
  'ANIMALCARE DOG 2*',
  'ANIMALCARE DOG 3*',
  'ANIMALCARE SUP DOGS',
  'ANIMALCARE STD DOGS',
  'ANIMALCARE CAT STD',
  'ANIMALCARE CAT SUPER',
  'ANIMALCARE DOG STD',
  'ANIMALCARE DOG SUPER',
  'FRISKIES / BETA STD',
  'FRISKIES /BETA SUPER',
  'STANDARD CAT',
  'SUPER CAT',
  'STANDARD DOG',
  'SUPER DOG',
  'HOOVER STANDARD CAT',
  'HOOVER STANDARD DOG',
  'HOOVER SUPER CAT',
  'HOOVER SUPER DOG',
  'PETS ABROAD CATS',
  'PETS ABROAD DOGS',
  'RAPIDCARE SUPERCOVER',
  'RAPIDCARE STANDARD',
  'STD CVR CATS (SALES)',
  'SUPER CVR DOGS SALES',
  'NEW SUPER COVER CATS',
  'NEW SUPER COVER DOGS',
  'SUPERPLUS COVER CATS',
  'SUPER COVER PLUS DOG',
  'NEW STD COVER CATS',
  'STANDARD COVER DOGS',
  'STANDARD COVER CATS',
  'NEW STD COVER DOGS',
  'SUPER COVER CATS',
  'SUPER COVER DOGS',
  'UMI',
  '(COMBI)',
  '6 MONTHS 25% DISCOUNT',
  'ACC DAMAGE SCHEME',
  'ALL MAKERS',
  'AO.COM UNBRANDED',
  'COMET PR 1+1',
  'COMET PR 2YR 1+1',
  'COMET PR 2YR EXTENDED',
  'COMET PR EXTENDED',
  'CURRYS DEFAULT LINE',
  'D&G DIGIBOX (INTERNAL USE ONLY',
  'D&G PR 1+1',
  'D&G PR 2YR 1+1',
  'D&G PR 2YR EXTENDED',
  'D&G PR EXTENDED',
  'DO NOT USE',
  'GENERIC BOG',
  'GENERIC NON-BOG',
  'LGH PHONE LINE',
  'MOD CO. E PROMO',
  'POLICY HOLDER OFFER',
  'REPLACEMENT PRODUCT',
  'SAFEWAY SIGNPOSTING',
  'SCHEME MOD COMP B',
  'SKY DIGIBOX (INTERNAL USE ONLY',
  'SSE PHONE LINE',
  'SUNENERGY',
  'TV LICENSING DATA',
  'D&G DIGIBOX (INTERNAL USE ONLY)',
  'SKY DIGIBOX (INTERNAL USE ONLY)',
  'JBL',
  'TOA',
  '16 EAST',
  '3D CONNEXION',
  '3D WERK',
  'AST',
  'ARGOZ',
  'Q-TE',
  'XXXX',
  'CIH',
  'D&G',
  'KI1412S30G_WH',
  'GPO',
  'D&G IPM 1 YR GUARANTEE',
  '3XS',
  'GENERAL ELECTRIC',
  'SCOTTISH POWER',
  'CURRYS ESSENTIALS',
  'IKEA (MULTIBRANDING)',
  'DIRECT PR 2YG INS FLEX',
  'DIRECT PR 1YG INS FLEX',
  'GDHA',
  'AO PR QUOTELINE',
  'CORNER FRIDGE CO',
  'WHITEWESTINGHOUSE',
  'NUMATIC INTNL. LTD.',
  'B&Q SINGLE APPLIANCE',
  'STOVES VALOUR',
  'LEISUR/FLAVEL TELREG',
  'PORTWAY',
  'RESPECTA',
  'NO TRADEMARK',
  'FRANKE',
  'GE APPLIANCES',
  'GORENJIE',
  'HIRUNDO',
  'PHILCO UK',
  'BLUE AIR',
  'COLSTON TR',
  'CONSUL',
  'DISCOVERY',
  'DOMOLINE',
  'ECOLINE',
  'EUROLINE',
  'EUROPA',
  'EVALET',
  'OFFICINA STAR',
  'ORIMA',
  'KAISER',
  'MIOSTAR',
  'NOGAMATIC',
  'DIRECT TEL REG 2YR 0-3M',
  'DIRECT TEL REG 2YR 4-11M',
  'DIRECT TEL REG 12-23M',
  'ANKER',
  'LEIS/FLAV 2YR TEL REG 0-3 IPM',
  'LEIS/FLAV 2YR TEL REG 4-11 IPM',
  'FLAV 2Y WEB REG BUILT-IN 4-EOG',
  'BLOMBERG 3YR TEL REG 4-11 IPM',
  'BLOMBERG 3YR TEL RG 12-EOG IPM',
  'LEIS/FLAV 2YR TEL RG 12-23 IPM',
  'HAHNEL',
  'RCA',
  'NESPRESSO',
  'ELECTRIQ',
  'TOWER',
  'EDF ENERGY',
  'HADEN',
  'HAIE',
  'SIMFER',
  'BELDRAY',
  'STEEL SERIES',
  'OPTI',
  'APELSON',
  'ALTIMO',
  'EASY KARAOKE',
  'HYPERX',
  'RING',
  'T4TEC',
  'AMAZFIT',
  'GEO',
  'PROFORM',
  'NORDICTRACK',
  'FREESAT',
  'META QUEST',
  'RUG DOCTOR',
  'META PORTAL',
  'VENTURER',
  'EUFY',
  'ECHELON',
  'SHOKZ',
  'GUILD',
  'HORI',
  'GOOGLE PIXEL',
  'NEBULA',
  'GROOV-E',
  'BAUMATIC TREG 0-3M INS FLEX',
  'PLAYSTATION VR',
  'PICO',
  'CAF ROYAL',
  'CHEFS CHOICE',
  'GLCKLER',
  'KNIG',
  'LECLANCH',
  'MENZ + KNECKE',
  'PETER JCKEL',
  'PHONAK AUDO PFE',
  'WETZELS KAFFEEMHLE',
  'ZBLIN',
  'JAMSTIK',
  'NACON',
  'INTERGAS',
  'ULTIMATE EARS',
  'MAJORITY',
  'JAYBIRD',
];
